import Vue from '@/main'
import { getCurrentTenant } from '@/utils'
import instance from "@/http/requests/instance"

export default {
  fetch({ commit }, searchParams = {}) {
    return new Promise((resolve, reject) => {
      instance.fetch(searchParams).then(response => {
        commit('SET_INSTANCES', response.data.data.instances)
        commit('EXISTS_CLOUD_CONNECTION', response.data.data.instances)

        Vue.$events.on('InstanceUpdated', (event) => {
          if (event.tenantName === getCurrentTenant()) {
            commit('UPDATE_INSTANCE', event.instance)
            commit('UPDATE_CHOSEN_INSTANCES', event.instance)
          }
        })

        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      instance.add(data).then(response => {
        commit('ADD_INSTANCE', response.data.data.createInstance)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      instance.update(data).then(response => {
        commit('UPDATE_INSTANCE', response.data.data.updateInstance)
        commit('UPDATE_CHOSEN_INSTANCES', response.data.data.updateInstance)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  delete({ commit }, instanceId) {
    return new Promise((resolve, reject) => {
      instance.delete(instanceId).then(response => {
        commit('DELETE_INSTANCE', instanceId)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  chooseInstance({ commit }, instanceId) {
    return new Promise((resolve) => {
      commit('CHOOSE_INSTANCE', instanceId)
      resolve({})
    })
  },
  chooseInstanceObject({ commit }, instance) {
    return new Promise((resolve) => {
      commit('CHOOSE_INSTANCE_OBJECT', instance)
      resolve({})
    })
  },
  chosenInstances({ commit }, instance) {
    return new Promise((resolve) => {
      commit('CHOSEN_INSTANCES', instance)
      resolve({})
    })
  },
  chooseRefreshInstancesObject({ commit }, instance) {
    return new Promise((resolve) => {
      commit('CHOOSE_REFRESH_INSTANCES_OBJECT', instance)
      resolve({})
    })
  },
  existsCloudConnection({ commit }){
    return new Promise((resolve, reject) => {
      instance.fetch({ is_official: true }).then(response => {
        commit('EXISTS_CLOUD_CONNECTION', response.data.data.instances)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  updateByIntegration({ commit }, data) {
    return new Promise((resolve, reject) => {
      instance.updateByIntegration(data).then(response => {
        commit('UPDATE_INSTANCE', response.data.data.updateInstanceIntegration)
        commit('UPDATE_CHOSEN_INSTANCES', response.data.data.updateInstanceIntegration)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  chosenInstancesUnion({commit}, userId){
    return new Promise((resolve, reject) => {
      instance.fetch({ user_id: userId, allowed_to_unify: true }).then(response => {
        commit('CHOSEN_INSTANCES', response.data.data.instances)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  }
}
